@let item = display();

<app-tooltip-item-preview #preview [display]="item">
  <div preview-footer class="mt-2 type-muted text-center">
    This trader's unique offering.
  </div>
</app-tooltip-item-preview>

<button
  appListRow
  [disabled]="!canAfford()"
  [tp]="item ? preview.template() : undefined"
  [tpPlacement]="'top'"
  (click)="activate.emit()"
  appSfx="ui-click"
  [sfxTrigger]="['click', 'hover']"
>
  @if (item) {
    <div class="flex flex-col items-center gap-2 shrink-0">
      <app-slot-rarity-outline
        [entry]="item"
        [spritesheet]="item.spritesheet"
      ></app-slot-rarity-outline>
    </div>

    <div class="flex flex-col flex-1 min-w-0 gap-2">
      <span class="type-entity-name truncate text-{{ item.rarity }}">
        {{ item.name }}
      </span>

      <span class="badge badge-sm badge-success">Unique</span>
    </div>

    <app-currency-cost
      [type]="traderTokenItemId"
      [amount]="trade().tokenCost"
      class="ml-auto mr-2 shrink-0"
    />
  }
</button>
